module.exports = __webpack_public_path__ + "assets/06a5fdaa00f042675b70fcb97c5b5484.png";